import React, { Component, ReactElement } from 'react';

import AcceptModal from 'buyside/components/presentation/JobApplicationShowPage/JobApplicationShowModal/ModalParts/AcceptModal';
import RejectModal from 'buyside/components/presentation/JobApplicationShowPage/JobApplicationShowModal/ModalParts/RejectModal';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import {
  JobApplication,
  HandleMutations
} from 'buyside/components/container/JobApplicationShowPage/jobApplicationShowPageMutationsContainer';

import { jobPostAppsUrl } from 'buyside/util/urlHelper';
const { jobApplicationStatuses } = require('buyside/util/constantsFromRails.json');

import StarIcon from 'buyside/svgs/star.svg';
import ThumbsUpIcon from 'buyside/svgs/thumbs_up.svg';
import ThumbsDownIcon from 'buyside/svgs/thumbs_down.svg';

type ApplicationOptionsProps = Pick<JobApplication, 'name' | 'starred' | 'status'> & {
  handleInterviewed: HandleMutations['handleInterviewed'];
  handleRejected: HandleMutations['handleRejected'];
  handleStarred: HandleMutations['handleStarred'];
  isFetching: boolean;
  jobPostingId: string;
  otherApplicationsCount: number;
};

import styles from './ApplicationOptionsStyles.scss';

class ApplicationOptions extends Component<ApplicationOptionsProps, { hover: boolean }> {
  constructor(props: ApplicationOptionsProps) {
    super(props);
    this.state = { hover: false };
  }

  render(): ReactElement {
    const {
      jobPostingId,
      status,
      name,
      starred,
      otherApplicationsCount,
      handleInterviewed,
      handleRejected,
      handleStarred,
      isFetching
    } = this.props;

    const { hover } = this.state;

    return (
      <div className={styles.container}>
        {otherApplicationsCount > 0 && (
          <a
            className={styles.link}
            href={jobPostAppsUrl(jobPostingId)}
            data-test="other-applications-link"
          >
            {'<< View'} {otherApplicationsCount} other application
            {otherApplicationsCount > 1 && 's'} for this role
          </a>
        )}
        <span
          onMouseEnter={(): void => this.setState({ hover: true })}
          onMouseLeave={(): void => this.setState({ hover: false })}
        >
          {starred ? (
            <Button
              data-test="unbookMark"
              text={hover ? 'Remove Bookmark' : 'Bookmarked'}
              icon={StarIcon}
              type={hover ? BUTTON_TYPES.DANGER : BUTTON_TYPES.PRIMARY}
              size={BUTTON_SIZES.SMALL}
              onClick={handleStarred}
              isLoading={isFetching}
            />
          ) : (
            <Button
              data-test="bookmark"
              text="Bookmark this Application"
              icon={StarIcon}
              size={BUTTON_SIZES.SMALL}
              isLoading={isFetching}
              onClick={handleStarred}
            />
          )}
        </span>

        <p className={styles.smallNote}>
          Bookmarking makes it easier to sort prospective hires.{' '}
          <i>
            Bookmarking does not mean you are making a candidate an offer or in any way committing
            to hiring that candidate.
          </i>{' '}
          Bookmarking a candidate's application does not notify the candidate.
        </p>

        <div>
          {status !== jobApplicationStatuses.rejected ? (
            <>
              <AcceptModal
                name={name}
                handleSubmit={handleInterviewed}
                interviewed={status === jobApplicationStatuses.interviewed}
                renderOpenButton={(openModal): ReactElement => (
                  <Button
                    data-test="accept-button"
                    size={BUTTON_SIZES.SMALL}
                    type={BUTTON_TYPES.MAJOR}
                    text={
                      status === jobApplicationStatuses.interviewed
                        ? 'Interview Requested'
                        : 'Request Interview'
                    }
                    icon={ThumbsUpIcon}
                    onClick={openModal}
                    disabled={status === jobApplicationStatuses.interviewed}
                  />
                )}
              />

              <RejectModal
                name={name}
                handleSubmit={handleRejected}
                renderOpenButton={(openModal): ReactElement => (
                  <span className={styles.buttonMargin}>
                    <Button
                      data-test="reject-button"
                      size={BUTTON_SIZES.SMALL}
                      type={BUTTON_TYPES.DANGER}
                      text="Reject"
                      icon={ThumbsDownIcon}
                      onClick={openModal}
                    />
                  </span>
                )}
              />
            </>
          ) : (
            <div>Rejected</div>
          )}
        </div>
      </div>
    );
  }
}

export default ApplicationOptions;
